// @flow
import React from 'react'
import moment from 'moment'
import I18n from 'i18n-react'

import { capitalizeFirstLetter } from '../InputHelpFunctions'

// types

type UserDataBoxProps = {
  data: { [key: string]: any },
  valueNames: { [key: string]: { [key: string]: string } },
}

export default class UserDataBox extends React.Component<UserDataBoxProps> {

  handleOnClick = () => {
    this.props.onClick('/')
  }

  render = () => {
    const userData = this.props.data
    if (!userData.policyHolder) {
      return null
    }

    const policyHolder = userData.policyHolder
    const user = userData.user
    const valueNames = this.props.valueNames

    const manufacturer = valueNames.manufacturer[userData.manufacturer] ?
      valueNames.manufacturer[userData.manufacturer] : userData.manufacturer
    const model = valueNames.manufacturer[userData.model] ?
      valueNames.manufacturer[userData.model] : userData.model
    const manualBonus = userData.bonusType === 'manually'

    return (
      <div className='card card-with-edit flex-md-row flex-xl-column justify-content-between with-default-bg px-4 py-3 mt-4'>
        <div className='card-header p-0 border-0 mb-2 d-flex justify-content-between order-md-2 order-xl-1'>
          <strong className='d-md-none d-xl-inline-block'>{I18n.translate('general.enteredData')}</strong>
          <a className='btn-link text-nowrap' onClick={this.handleOnClick}>
            <strong><u>{I18n.translate('general.changeData')}</u></strong>
          </a>
        </div>
        <ul className='list mb-0 d-md-flex flex-wrap d-xl-block order-md-1'>
          <li className='mr-md-3 mr-xl-0'>
            <strong className='d-block d-md-inline d-xl-block pr-2'>{I18n.translate('components.userDataBox.policyHolder')}</strong>
            {policyHolder.birthDate && `${moment(policyHolder.birthDate).format('D.M.YYYY')}, `}{policyHolder.town}, {policyHolder.zip},
            {` ${I18n.translate('components.userDataBox.monthsWithAccidents')}: ${manualBonus ? userData.monthsWithAccidents : '-'},`}
            {` ${I18n.translate('components.userDataBox.countOfAccidents')}: ${manualBonus ? userData.countOfAccidents : '-'}`}
          </li>
          <li className='mr-md-3 mr-xl-0'>
            <strong className='d-block d-md-inline d-xl-block pr-2'>{valueNames.type[userData.type]}</strong>
            {manufacturer && model && `${capitalizeFirstLetter(manufacturer)} ${capitalizeFirstLetter(model)}, `}
            {userData.capacity && <span>{userData.capacity}&nbsp;cm<sup>3</sup>, </span>}
            {userData.power && `${userData.power} kW,`}
            {` ${I18n.translate('components.userDataBox.yearOfConstructionWithLabel', { year: userData.yearOfConstruction })}`}
          </li>
          <li className='mr-md-3 mr-xl-0'>
            <strong className='d-block d-md-inline d-xl-block pr-2'>{I18n.translate('components.userDataBox.user')}</strong>
            {userData.userSameAsPolicyHolder || !user ? I18n.translate('components.userDataBox.userSameAsPolicyHolder') :
              `${user.birthDate && `${moment(user.birthDate).format('D.M.YYYY')}, `}${user.town}, ${user.zip}`}
          </li>
        </ul>
      </div>
    )
  }
}
